(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('SmsPattern', SmsPattern);

    SmsPattern.$inject = ['$resource', 'ENV'];

    function SmsPattern($resource, ENV) {

        var getAllPatterns = function() {
            // var resourceUrl = ENV.API_BASE_URL + 'api/v2/marketing-campaigns/get-all-checking';
            var resourceUrl = ENV.API_BASE_URL + 'api/_search/marketing-campaign';

            return $resource(resourceUrl, {}, {
                'query': {method: 'GET'},
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                'update': {method: 'PUT'}
            });
        }

        var getPatternItem = function() {
            var resourceUrl = ENV.API_BASE_URL + 'api/marketing-campaign/:id';

            return $resource(resourceUrl, {}, {
                'query': {method: 'GET', isArray: true},
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                'update': {method: 'PUT'}
            });
        }
        var updateItem = function() {
            var resourceUrl = ENV.API_BASE_URL + 'api/v2/marketing-campaigns';

            return $resource(resourceUrl, {}, {
                'update': {method: 'PUT'}
            });
        }
        var createItem = function() {
            var resourceUrl = ENV.API_BASE_URL + 'api/marketing-campaign';

            return $resource(resourceUrl, {}, {
                'save': {method: 'POST'}
            });
        }

        return {
            getAllPatterns:getAllPatterns ,
            getPatternItem:getPatternItem,
            updateItem:updateItem,
            createItem:createItem
        };
    }
})();
